import * as React from 'react';
import WebGLDirector from '../../webGL/WebGLDirector';
import GLComponent from './GLComponent';
import WebGLText from '../../webGL/WebGLText';
import WebGLLine from '../../webGL/shapes/primitives/WebGLLine';
import WebGLTextOrientation from '../../webGL/WebGLTextOrientation';
import WebGLLineStrip from '../../webGL/shapes/primitives/WebGLLineStrip';
import MathComponent from '../../shared/MathComponent';
import WebGLPolygon from '../../webGL/shapes/primitives/WebGLPolygon';

export default class Angles2Component extends GLComponent {

	public constructor () {
		super();
		this.heightFactor = 1 / 4;
	}

	componentDidMount () {
		const director = new WebGLDirector(this.canvas, this.props.width, this.props.height, this.textOverlay);

		director.addShape(WebGLLine.fromNumbers(-.95, -.2, -.55, .2));
		director.addShape(WebGLPolygon.circle(-.95, -.2, 0.005, 64));
		director.addShape(WebGLLine.fromNumbers(-.95, -.2, -.55, -.2));
		director.addShape(WebGLLineStrip.circle(-.95, -.2, .05, 20, 0, Math.PI / 4));
		director.addText(new WebGLText('Acute angle', -.95, -.2, WebGLTextOrientation.BOTTOM_RIGHT));
		director.addText(new WebGLText(<MathComponent value='\\lt90^\\circ' />, -.875, -.2));

		director.addShape(WebGLLine.fromNumbers(-.45, -.2, -.45, .2));
		director.addShape(WebGLLine.fromNumbers(-.45, -.2, -.05, -.2));
		director.addShape(WebGLLine.fromNumbers(-.45, -.15, -.4, -.15));
		director.addShape(WebGLLine.fromNumbers(-.4, -.15, -.4, -.2));
		director.addShape(WebGLPolygon.circle(-.45, -.2, 0.005, 64));
		director.addText(new WebGLText('Right angle', -.45, -.2, WebGLTextOrientation.BOTTOM_RIGHT));
		director.addText(new WebGLText(<MathComponent value='90^\\circ' />, -.375, -.20));

		director.addShape(WebGLLine.fromNumbers(.05, -.2, -.4, .2));
		director.addShape(WebGLLine.fromNumbers(.05, -.2, .45, -.2));
		director.addShape(WebGLLineStrip.circle(.05, -.2, .05, 60, 0, Math.PI / 4 * 3));
		director.addShape(WebGLPolygon.circle(.05, -.2, 0.005, 64));
		director.addText(new WebGLText('Obtuse angle', .05, -.2, WebGLTextOrientation.BOTTOM_RIGHT));
		director.addText(new WebGLText(<MathComponent value='\\gt90^\\circ' />, .125, -.2));

		director.addShape(WebGLLine.fromNumbers(.55, -.2, .95, -.2));
		director.addShape(WebGLLineStrip.circle(.75, -.2, .05, 80, 0, Math.PI));
		director.addShape(WebGLPolygon.circle(.75, -.2, 0.005, 64));
		director.addText(new WebGLText('Straight angle', .575, -.2, WebGLTextOrientation.BOTTOM_RIGHT));
		director.addText(new WebGLText(<MathComponent value='180^\\circ' />, .7, -.15));

		director.drawScene();
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/lesson/WebGL/Angles2Component.tsx